module.exports = __webpack_public_path__ + "img/icon-star.db4c304d.svg";